import React from "react";
import { Icon } from "@/components/Icon";

export type KeyFeatureProps = {
  attribute: string;
  title: string;
  description: string;
};

export type SolutionsProps = {
  title: string;
  highlight: string;
  solutions: { icon?: React.JSX.Element; title: string; description: string }[];
};

export default function ProductSolutionsSection({
  title,
  highlight,
  solutions,
}: SolutionsProps) {
  const [before, after] = title.split(highlight);

  return (
    <section className="flex flex-col gap-10">
      <div className="flex justify-center md:text-center md:items-center flex-col gap-4">
        <p className="flex items-center md:justify-center">
          <span className="bg-[#E7D7FD] rounded-full px-3 py-1 text-[#8937F4] inline-block font-semibold">
            SOLUTIONS
          </span>
        </p>
        <h2 className="md:text-[45px] text-2xl text-secondary-900 font-bold leading-tight">
          {before}{" "}
          <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
            {highlight}
          </span>{" "}
          {after}
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-6 gap-12 items-stretch">
        {solutions.map((solution) => (
          <div className="border bg-[#FAFAFA] border-[#FAFAFA] rounded-lg py-10 text-center p-4 flex flex-col items-center gap-4  hover:bg-gradient-to-r hover:from-[#4337cc] hover:to-primary-900 group relative ">
            <div className="absolute -top-6">{solution.icon}</div>

            <div className="flex flex-col gap-4 mt-8">
              <span className="text-secondary-900 text-xl md:text-2xl font-bold group-hover:text-white md:min-h-[60px]">
                {solution.title}
              </span>
              <span className="text-secondary-900 group-hover:text-white text-lg font-medium">
                {solution.description}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
